import script from "./ColorSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorSelector.vue?vue&type=script&setup=true&lang=js"

import "./ColorSelector.vue?vue&type=style&index=0&id=3ed74269&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed74269"]])

export default __exports__